import script from "./UnsafeExclusionPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsafeExclusionPicker.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./UnsafeExclusionPicker.vue?vue&type=style&index=1&id=fbf88fe8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbf88fe8"]])

export default __exports__